import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { PartnerCodesEffects } from './partner-codes.effects';
import { STORE_TYPE } from './partner-codes.model';
import { partnerCodesReducer } from './partner-codes.reducer';

export const UIPartnerCodesStoreModule = [
  StoreModule.forFeature(STORE_TYPE, partnerCodesReducer),
  EffectsModule.forFeature([PartnerCodesEffects]),
];